import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import {
  statusNotificationRender,
  typeNotificationRender,
} from "../utils/cellRenderTable";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchDeleteNotification } from "../actions/notification";
import { fetchNotificationSyestemList } from "../actions/notification";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const NotificationSystemList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "notifications";
  const pageType = "SystemList";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { notificationSystemList } = useSelector(
    (state) => state.notificationReducer
  );

  useEffect(() => {
    dispatch(fetchNotificationSyestemList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLink={`/notification-edit-system/` + params.data.id}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteNotification(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: "Država",
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 200,
    },
    {
      headerName: "Naziv notifikacije",
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "Naslov notifikacije",
      field: "title",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={notificationSystemList}
        columnDefs={columnDefs}
        gridStateKey={"notification-system-list"}
        // buttonLink={`/notification-add`}
        // buttonText={t(`breadcrumb.${translateModule}Add`)}
      />
    </Fragment>
  );
};

export default NotificationSystemList;
